module.exports = __webpack_public_path__ + "img/fool.68306069.png";